'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap } from 'immutable';
import PortalIdParser from 'PortalIdParser';
const PORTAL_ID = PortalIdParser.get();
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.HUB_ATTRIBUTES_FETCH_SUCCEEDED:
      {
        const {
          settings
        } = payload;
        return settings.filter(setting => setting.hubId === PORTAL_ID).reduce((newState, setting) => newState.set(setting.key, setting.value), ImmutableMap());
      }

    case Actions.HUB_ATTRIBUTES_SYNC_SUCCEEDED:
      return state.set(payload.key, payload.value);

    default:
      return state;
  }
});